import { cx } from "@/shared/ui/primitives";
import { meterSegments } from "./call-support";

const SEGMENTS = 8;

/** The volume of a voice as a row of lights (ADR 0067); decorative, the text says who it is. */
export function LevelMeter({
  level,
  label,
  className,
}: {
  level: number;
  label: string;
  className?: string;
}) {
  const lit = meterSegments(level, SEGMENTS);
  return (
    <span className={cx("level-meter", className)}>
      <span className="level-meter__label">{label}</span>
      <span className="level-meter__lights" aria-hidden="true">
        {Array.from({ length: SEGMENTS }, (_, index) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: the lights are fixed positions.
            key={index}
            className={cx("level-meter__light", index < lit && "level-meter__light--on")}
          />
        ))}
      </span>
    </span>
  );
}
